import { Component, Inject, OnInit, inject, DestroyRef } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { Action } from '../../../models';
import { ActionService } from '../../../services';
import { ButtonComponent } from '@shared/components/button/button.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { InputComponent } from '@shared/components/input/input.component';
import { NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';
import { ToastAlertService } from '@core/services';

@Component({
  selector: 'app-actions-create-modal',
  templateUrl: './actions-create-modal.component.html',
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogContent,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    InputComponent,
    MatSelectModule,
    MatOptionModule,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
  ],
})
export class ActionsCreateModalComponent implements OnInit {
  formBuilder = inject(FormBuilder);
  actionService = inject(ActionService);
  operation = '';
  actionForm!: any;
  private destroyRef = inject(DestroyRef);
  private alertService = inject(ToastAlertService);
  private dialogRef = inject(MatDialogRef<ActionsCreateModalComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: Action) {
  }

  ngOnInit(): void {
    if (this.data?.actionid) {
      this.operation = 'Modificar';
      this.actionForm = this.formBuilder.group({
        id: [this.data.actionid],
        name: [this.data.name, [Validators.required, Validators.maxLength(50)]],
        code: [this.data.actioncode, Validators.required],
        description: [
          this.data.description,
          [Validators.required, Validators.maxLength(256)],
        ],
        type: [this.data.type, Validators.required],
      });
    } else {
      this.operation = 'Crear';
      this.actionForm = this.formBuilder.group({
        id: ['0'],
        name: ['', [Validators.required, Validators.maxLength(50)]],
        code: ['', Validators.required],
        description: ['', [Validators.required, Validators.maxLength(256)]],
        type: ['', Validators.required],
      });
    }
  }

  get id_action() {
    return this.actionForm.get('id');
  }

  submit() {
    const obj: Action = {
      actionid: this.actionForm.controls['id'].value,
      name: this.actionForm.controls['name'].value,
      actioncode: this.actionForm.controls['code'].value,
      description: this.actionForm.controls['description'].value,
      type: this.actionForm.controls['type'].value,
    };
    if (this.data && this.actionForm.valid) {
      this.actionService
        .updateAction(obj, Number(this.data.actionid))
        .subscribe({
          next: response => {
            if (response.status === 'OK') {
              this.dialogRef.close(true);
              this.alertService.sucess('Actualizado');
            } else {
              this.alertService.error('Error al actualizar');
            }
          },
        });
    } else if (this.actionForm.valid) {
      this.actionService.storeAction(obj).subscribe({
        next: response => {
          if (response.status === 'OK') {
            this.dialogRef.close(true);
            this.alertService.sucess('Creado correctamente');
          }
        },
      });
    }
  }

  clearForm() {
    this.ngOnInit();
  }
}
